import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import apiClient from '../Api/axiosConfig';
import trackEvent from '../services/AnalyticsService';
import FeedbackForm from '../Components/FeedbackForm';
import './BookDetail.css';

const BookDetail = ({ books, feedbacks, onFeedbackSubmit }) => {
  const { bookId } = useParams();
  const book = books.find(b => b.id === bookId);
  
  const [isExpanded, setIsExpanded] = useState(false);

  if (!book) {
    const bookExists = books && books.some(b => b.id === bookId);
    if (!bookExists && books) {
        return (
            <div className="detail-container">
                <h1>A FÁJL SÉRÜLT</h1>
                <Link to="/letoltesek">Vissza a könyvtárba</Link>
            </div>
        );
    }
    return <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>Adatok betöltése...</div>;
  }
  
  const bookFeedbacks = feedbacks.filter(fb => fb.bookId === book.id);
  const descriptionLength = book.description.length;
  const isLongDescription = descriptionLength > 1000;

  // --- ITT VAN A FRISSÍTETT LETÖLTÉS KEZELŐ ---
  const handleDownload = async (format) => {
    try {
        await apiClient.post('/data/trackDownload', { bookId: book.id, format: format });        
        if (onFeedbackSubmit) { onFeedbackSubmit(); }
    } catch (error) {
        console.error("Hiba a letöltés követésekor:", error);
    } finally {
        // 4. Lépés: Mindenképpen elindítjuk a letöltést, még ha a követés sikertelen is
        console.log(book.downloads, format);
        const link = document.createElement('a');
        link.href = book.downloads[format].url;
        link.setAttribute('download', '');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
  };

  return (
    <div className="detail-container">
      <div className="detail-card">
        <div className="detail-sidebar">
          <img src={book.coverImage} alt={`${book.title} borító`} className="detail-cover" />
          <div className="detail-downloads">
            {book.downloads.pdf?.url && book.downloads.pdf?.url !== "#" && (
              <button onClick={() => handleDownload('pdf')} className="detail-button" download>
                PDF <span className="download-count">({book.downloads.pdf.count} letöltés)</span>
              </button>
            )}
            {book.downloads.epub?.url && book.downloads.epub?.url !== "#" && (
              <button onClick={() => handleDownload('epub')} className="detail-button" download>
                EPUB <span className="download-count">({book.downloads.epub.count} letöltés)</span>
              </button>
            )}
            {book.downloads.mobi?.url && book.downloads.mobi?.url !== "#" && (
              <button onClick={() => handleDownload('mobi')} className="detail-button" download>
                MOBI <span className="download-count">({book.downloads.mobi.count} letöltés)</span>
              </button>
            )}
          </div>
        </div>
        <div className="detail-main-content">
          <h1 className="detail-title">{book.title}</h1>
          
          <div 
            className={`detail-description ${isLongDescription && !isExpanded ? 'collapsed' : ''}`}
            dangerouslySetInnerHTML={{ __html: book.description }} 
          />
          
          {isLongDescription && (
            <button onClick={() => setIsExpanded(!isExpanded)} className="expand-button">
              {isExpanded ? 'Kevesebb' : 'Több'}
            </button>
          )}

          <hr />
          <div className="feedback-section">
            <FeedbackForm bookId={book.id} onSuccess={onFeedbackSubmit} />
          </div>
          <hr />
          <div className="feedback-list">
            <h2>Visszajelzések ({bookFeedbacks.length})</h2>
            {bookFeedbacks.length > 0 ? (
                bookFeedbacks.slice(0).reverse().map(fb => (
                    <div key={fb.timestamp} className="feedback-item">
                        <div className="feedback-header">
                            <span className="feedback-nickname">{fb.nickname}</span>
                            <span className="feedback-stars">
                                {[...Array(5)].map((_, i) => (
                                    <span key={i} className={i < fb.rating ? 'star-filled' : 'star-empty'}>&#9733;</span>
                                ))}
                            </span>
                        </div>
                        <p className="feedback-text">{fb.text}</p>
                    </div>
                ))
            ) : (
                <p>Még nem érkezett visszajelzés ehhez a könyvhöz. Légy te az első!</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookDetail;